import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';

import { ComponentDefinition, IApprovalButtonsConfiguration, IApproval, ApprovalStatus } from '../../models';
import { momentFormat } from '../../common';

class ApprovalButtons implements angular.IComponentController {
    allButtonsDisabled: boolean;
    approvals: IApproval[];
    config: IApprovalButtonsConfiguration;
    timestamp: Date;
    title: string;

    readonly isDisabled: boolean;

    private _unsubscribe: Function;

    static $inject = [
        '$scope',
        '$q'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$q: angular.IQService
    ) {
        this.config = {} as IApprovalButtonsConfiguration;
        this.allButtonsDisabled = false;
    }

    $onInit() {
        this.watchConfig();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['timestamp']?.currentValue) {
            this.updateApprovals();
        }

        if (changesObj['config']?.currentValue) {
            if (this._unsubscribe) {
                this._unsubscribe();
            }
            this.watchConfig();
        }
    }

    updateApprovals() {
        if (this.config) {

            this.title = '';
            this.allButtonsDisabled = false;
            const date = this.timestamp ?? this.config.timestamp;
            if (!this.config.allowFuture && !!date && this.isFutureRange(date)) {
                //if (!this.config.allowFuture && this.isFutureRange(this.config.timestamp)) {
                this.title = 'Data can not be approved in the future';
                this.allButtonsDisabled = true;
            }

            if (this.config.approvalsByDate && Object.keys(this.config.approvalsByDate).length > 0) {
                if (this.timestamp) {
                    const dateKey = moment(this.timestamp).format(momentFormat);
                    this.approvals = this.config.approvalsByDate[dateKey];
                }
            } else if (this.config.approvals && this.config.approvals.length > 0) {
                this.approvals = this.config.approvals;
            }
        }
    }

    changeStatus(approval: IApproval, status: ApprovalStatus): angular.IPromise<void> {
        if (approval.status !== status && this.userHasRight(approval.level)) {
            return this.config.approve(approval.level, status, this.timestamp);
        }
        return this._$q.when();
    }

    userHasRight(level): boolean {
        return this.config.currentUserLevels.indexOf(level) >= 0;
    }

    private isFutureRange(date: Date): boolean {
        return (this.config.interval)
            ? moment(date)
                .add(this.config.interval.interval, this.config.interval.unit)
                .isAfter(moment())
            // fallback if no interval provided
            : moment(date).isAfter(moment());
    }

    private watchConfig(): void {
        this._unsubscribe = this._$scope.$watch(() => this.config, () => {
            this.updateApprovals();
        }, true);
    }
}

export const wtApprovalButtons: ComponentDefinition = {
    componentId: 'wtApprovalButtons',
    controller: ApprovalButtons,
    template: require('./approvalButtons.component.html'),
    controllerAs: 'vm',
    bindings: {
        config: '<',
        isDisabled: '<?',
        timestamp: '<?'
    }
};